import {serializable, alias, primitive, object, list } from 'serializr';

export class Date {
    @serializable(alias('exam_date', primitive()))
    examDate?: string;

    @serializable(alias('days_remaining', primitive()))
    daysRemaining?: string;
}